import { DocumentDialogComponent } from '@sdbn/tmc-legacy';
import { ApplicationRef, Component, Input, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AppClientConfiguration } from '@sdbn/common';
import { ImagePreviewDialog } from '@sdbn/common';
import { DocumentPreview, TransportDocumentType } from '../../../../../components/transport-details-legacy/model/document-preview';
import { TransportDetailsService } from '../../../../../components/transport-details-legacy/service/transport-details.service';
import { AbstractWidgetComponent } from '@sdbn/common';
import { Subject, Subscription } from 'rxjs';

@Component({
    selector: 'app-transport-documents-list',
    templateUrl: './transport-documents-list.component.html',
    styleUrls: ['./transport-documents-list.component.scss'],
    standalone: false
})
export class TransportDocumentsListComponent extends AbstractWidgetComponent implements OnDestroy {

  requestRunning = false;

  @Input('transportId') set setTransportId(value: number) {
    this.transportId = value;
    this.loadDocumentPreviews();
  }

  @Input('forceReloadRequest') set setForceReloadRequest(value: Subject<void>) {
    if (this.forceReloadRequestSubscription != null) {
      this.forceReloadRequestSubscription.unsubscribe();
    }
    this.forceReloadRequest = value;
    this.forceReloadRequestSubscription = value.subscribe(() => {
      this.loadDocumentPreviews();
    });
  }

  forceReloadRequest: Subject<void>;
  forceReloadRequestSubscription: Subscription;

  transportId: number;

  // documentType = TransportDocumentType;
  documentPreviews = new Array<DocumentPreview>();

  constructor(
    // private dialogService: DialogService,
    private dialog: MatDialog,
    private applicationRef: ApplicationRef,
    private transportDetailsService: TransportDetailsService,
    // private appServerAPI: AppServerAPI
    private appClientConfiguration: AppClientConfiguration
  ) {
    super();
  }

  ngOnDestroy(): void {
    if (this.forceReloadRequestSubscription != null) {
      this.forceReloadRequestSubscription.unsubscribe();
    }
    super.ngOnDestroy();
  }

  private loadDocumentPreviews() {
    this.requestRunning = true;
    this.transportDetailsService.getDocumentPreviews({ id: this.transportId }).subscribe(
      documentPreviews => {
        this.documentPreviews = new Array<DocumentPreview>();
        for (const dp of documentPreviews) {
          this.documentPreviews.push(dp);
        }
        this.requestRunning = false;
      },
      error => {
        this.requestRunning = false;
      }
    );
  }

  // onContextChange(contextChange: ContextChange) {
  //   try {
  //     if (contextChange.key === 'selected-transport') {
  //       const selectedTransport = this.dashboardContext.context.get('selected-transport');
  //       if (selectedTransport != null && selectedTransport.id != null && selectedTransport.id !== this.transportId) {
  //         this.transportId = selectedTransport.id;
  //         this.loadDocumentPreviews();
  //       }
  //     }

  //     if (contextChange.key === 'transport-changed') {
  //       if (this.transportId != null) {
  //         this.loadDocumentPreviews();
  //       }
  //     }
  //   } catch (e) {
  //     this.documentPreviews = new Array<DocumentPreview>();
  //   }
  // }

  // onSetElementAndContext() {
  //   const transport = this.dashboardContext.context.get('selected-transport');
  //   if (transport != null && transport.id != null) {
  //     this.transportId = transport.id;
  //     this.loadDocumentPreviews();
  //   }
  // }

  // public refreshDocuments() {
  //   this.loadDocumentPreviews();
  // }

  // public createPicturePreviewUrl(preview: DocumentPreview): string {
  //   return this.createUrl(preview.previewResourceUUID) + '?type=thumb';
  // }

  public createUrl(previewResourceUUID: string): string {
    return this.appClientConfiguration.serverURLRoot + '/client/resource/archive/' + previewResourceUUID;
  }

  public listItemClick(preview: DocumentPreview) {
    if (preview.type === TransportDocumentType.APP_DOCUMENT) {
      this.showAppDocument(preview);
    } else if (preview.type === TransportDocumentType.PICTURE) {
      this.showPictureDocument(preview);
    }
  }

  private showAppDocument(preview: DocumentPreview) {
    this.transportDetailsService.getAppDocumentDetails(preview).subscribe(
      details => {

        const dialogRef = this.dialog.open(DocumentDialogComponent, {
          height: '800px',
          width: '800px',
          data: {
            documentIds: [details.documentId], documentTemplateId: details.documentTemplateId, transportId: this.transportId,
            addDocumentsEnabled: false
          },
          panelClass: 'tmc-dialog-container'
        });
        dialogRef.afterClosed().subscribe(() => this.loadDocumentPreviews());

        this.applicationRef.tick();
      }
    );
  }

  private showPictureDocument(preview: DocumentPreview) {
    this.transportDetailsService.getPictureDocumentDetails(preview).subscribe(
      details => {
        const dialogRef = this.dialog.open(ImagePreviewDialog,
          {
            maxWidth: '100vw',
            maxHeight: '100vh',
            height: '96%',
            width: '96%',
            panelClass: 'tmc-dialog-container'
          });
        dialogRef.componentInstance.imageSrc = this.createUrl(details.resourceUUID);
        dialogRef.componentInstance.transportResourceId = details.transportResourceId;
        dialogRef.componentInstance.syncWithTime = details.syncWithTime;
        dialogRef.componentInstance.syncWithTimeAvailable = details.syncWithTimeAvailable;
        dialogRef.componentInstance.descriptionEnabled = true;
        dialogRef.componentInstance.description = details.description;
        dialogRef.componentInstance.setSyncWithTimeEnabled(details.syncWithTimeEnabled);
        dialogRef.componentInstance.setMimetype(details.mimeType);
        dialogRef.componentInstance.dialogRef = dialogRef;

        dialogRef.afterClosed().subscribe(result => {
          preview.title = result;
        });
        this.applicationRef.tick();
      }
    );
  }

  // public handlePictureEvent(event: Event) {
  //   this.requestRunning = true;
  //   const files = (event.target as HTMLInputElement).files;
  //   if (files != null) {
  //     for (let i = 0; i < files.length; i++) {
  //       const current: File = files.item(i);
  //       const name = current.name;
  //       const type = current.type;

  //       if (current.size > 10 * 1024 * 1024) {
  //         this.dialogService.showInfoDialog(
  //             'tmc-yard.ui.transport.details.dialog.invalid-file-size.title',
  //             'tmc-yard.ui.transport.details.dialog.invalid-file-size.message');
  //         return;
  //       }

  //       const reader = new FileReader();
  //       reader.onload = () => {
  //         this.saveDocument(type, name, reader.result);
  //       };
  //       reader.readAsArrayBuffer(current);

  //     }
  //   }
  // }

  // private saveDocument(type: string, name: string, content: any) {
  //   console.log(content);
  //   return this.appServerAPI.executeFile(`${environment.transportDocumentUploadEndpoint}`, content, new HttpHeaders({
  //     'Content-Type': type,
  //     'Content-MD5': 'test', // TODO: Calculate MD5 hash of capture.blob
  //     transportId: '' + this.transportId,
  //     filename: encodeURIComponent(name)
  //   })).toPromise().then(response => {
  //     console.log('saveDocument call succeeded:', response);
  //     this.loadDocumentPreviews();
  //     this.requestRunning = false;
  //   }, error => {
  //     console.log('saveDocument call failed:', error);
  //     this.requestRunning = false;
  //   });
  // }



}
